module.exports = __webpack_public_path__ + "img/20.43d8eb0d.png";